import { SelectChangeEvent } from "src/components/MuiGenerals";
import SpenderAddressSelection from "src/components/SpenderAddress/SpenderAddressSingleSelection";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";

function SpenderAddressSingleSelection({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: SelectChangeEvent<string>) => void;
}) {
  const { fields, translate: t } = useBatchApproveAllowanceFormContext();
  const label = t("spender_address");

  return (
    <>
      <div>{label}</div>
      <SpenderAddressSelection
        fieldName={label}
        value={value}
        onChange={onChange}
        chainName={fields.chainName}
        currency={fields.currency}
      />
    </>
  );
}

export default SpenderAddressSingleSelection;
